<template>
    <div class="d-flex w-100 d-inline">
        <div class="w-100" id="filtrosRecargos">
            <Button
            :size="15"
            color="#fd7e14"
            colorText="#ffffff"
            tooltip="Filtrar contenido"
            icon="fas fa-filter"
            round
            :width="30"
            class="mt-2 mb-3 mr-2"
            @click.native="openModal()"
            traslate
            />

        
            <ui-modal
                ref="modal"
                title="Filtros Recargos"
                transition="scale-up"
                size="large"
                @close="actionSetShowModalFiltrosTarifasRecargos( false );"
            >
                <div class="container-fluid" >
                    <div class="row w-100">
                        <div class="col-4">
                            <ui-select 
                                class="w-100" 
                                label="Tipo Recargo" 
                                placeholder="Seleccione"
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroTypeRecharge"
                                multiple
                                has-search
                                searchPlaceholder="Buscar"
                                v-model="typeRecharge"
                            />
                        </div>

                        <div class="col-4">
                            <ui-select 
                                class="w-100" 
                                label="Naviera" 
                                placeholder="Seleccione"
                                multiple
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroNaviera" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="naviera"
                            />
                        </div>
                        
                        <div class="col-4">
                            <ui-select 
                                class="w-100" 
                                label="Naviera Salida" 
                                placeholder="Seleccione"
                                multiple
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroNaviera" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="navieraDeparture"
                            />
                        </div>

                    </div>
                    <div class="row w-100">

                        <div class="col-4">
                            <ui-select 
                                class="w-100" 
                                label="POL"
                                multiple
                                placeholder="Seleccione"
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroPol" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="pol"
                            />
                        </div>

                        <div class="col-4">
                            <ui-select 
                                class="w-100" 
                                label="POD"
                                multiple 
                                placeholder="Seleccione"
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroPod" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="pod"
                            />
                        </div>
                    </div>

                    <div class="row w-100">
                        <div class="col-4">
                            <label class="label-datepicker" >Desde</label>

                            <date-picker 
                                class=" w-100" 
                                format="YYYY-MM-DD" 
                                type="date" 
                                valueType="format"
                                v-model="from"
                            />
                        </div>

                        <div class="col-4">
                            <label class="label-datepicker" >Hasta</label>

                            <date-picker 
                                label="Hasta"
                                class="w-100" 
                                format="YYYY-MM-DD" 
                                type="date" 
                                valueType="format"
                                v-model="to"
                            />
                        </div>

                    
                    </div>

                    <div class="row w-100 mt-3">
                    

                        <div class="col-4">

                            <ui-select 
                                class="w-100" 
                                label="Atmósfera" 
                                placeholder="Seleccione"
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroAtmosfera" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="atmosfera"
                            />
                        </div>

                        <div class="col-4">
                            <ui-select 
                                class="w-100" 
                                label="Unidad" 
                                placeholder="Seleccione"
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroContainer" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="container"
                            />
                        </div>
                        <div class="col-4">
                            <ui-select 
                                class="w-100" 
                                label="Commodity" 
                                placeholder="Seleccione"
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroCommodity" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="commodity"
                            />
                        </div>

                    </div>

                    <div class="row w-100 mt-3">
        
                        <div class="col-4">
                            <ui-select
                                class="w-100" 
                                label="Unidad De Pago" 
                                placeholder="Seleccione"
                                :keys="{ value: 'id', label: 'name' }" 
                                :options="filtroUnityPayment" 
                                has-search 
                                searchPlaceholder="Buscar"
                                v-model="unityPayment"
                            />
                        </div>

                    </div>

        
                    <div class="row w-100 my-4">
                        <div class="col-3">
                            <button class="btn btn-default" @click="cerrarModal()" :disabled="disabledBtn">Cerrar</button>
                        </div>
                        <div class="col-9" >

                            <button 
                                v-if="showModalFiltrosTarifasRecargos" 
                                class="btn btn-outline-primary ml-2 float-right" 
                                @click="exportExcel()"
                                :disabled="disabledBtn"
                            >
                                Generar Reporte
                            </button>

                            <button 
                                class="btn btn-success float-right"
                                @click="filtrar()"
                                :disabled="disabledBtn"
                            >
                                Filtrar
                            </button>


                            <button 
                                class="btn btn-default float-right mr-3" 
                                @click="resetForm()" 
                                :disabled="disabledBtn"
                            >
                                Limpiar
                            </button>

                        </div>
                    </div>
                    
                </div>
            </ui-modal>
        </div>
        <div class="w-100">
            <Button
                :size="15"
                color="#dc3545"
                colorText="#ffffff"
                tooltip="Recargar Tabla"
                icon="fas fa-filter"
                round
                :width="30"
                class="mt-2 mb-3 mr-2"
                traslate
                @click.native="recargarTabla()"
            />
        </div>
    </div>
   
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from '../../../../common/Button';

import { getRecargos, getRechargeFiltros, getTariffRechargeExport } from '../../../../../constants/lineas';

import DatePicker from "vue2-datepicker";
import { downloadFile } from '../../../../../mixins';

export default {

    components:{
        Button,
        DatePicker
    },
    data() {
        return {
            naviera:[],
            navieraDeparture: [],
            pol:[],
            pod:[],
            from: "",
            to: "",
            neta: "",
            public_value: "",
            atmosfera:{},
            container:{},
            commodity:{},
            unityPayment:{},
            typeRecharge:[],
            //filtros
            navieras:[],
            ports:[],
            atmosferas: [],
            containers: [],
            products:[],
            unityPayments:[],
            disabledBtn: false,

        }
    },
    computed: {
        ...mapState("lineas", [
            "showModalFiltrosTarifasRecargos",
            'filtroTypeRecharge',
            'filtroNaviera',
            'filtroPol',
            'filtroPod',
            'filtroAtmosfera',
            'filtroContainer',
            'filtroCommodity',
            'filtroUnityPayment',
        ]),

    },
    methods: {

        ...mapActions(["ActionSetZindexTablaModal"]),

        ...mapActions("lineas", ["actionSetShowModalFiltrosTarifasRecargos", 'actionSetDataDatatableTarifasRecargos', 'actionSetFilterStateRecargos']),

        closeModalEvent(){
            this.ActionSetZindexTablaModal( false ); 
        },
        generatePayload(){
            return {
                tariff_recharges_type : this.typeRecharge.length > 0 ? this.typeRecharge.map( tr => tr.id ) : [] ,
                naviera_id            : this.naviera.length      > 0 ? this.naviera.map( n => n.id ) : [],
                naviera_id_departure  : this.navieraDeparture.length  > 0 ? this.navieraDeparture.map( n => n.id ) : [],
                pol        : this.pol.length > 0 ? this.pol.map( pl => pl.id ) : [] ,
                pod        : this.pod.length > 0 ? this.pod.map( pd => pd.id ) : [] ,
                from       : this.from ?? "",
                to         : this.to ?? "",
                products_category_id : this.commodity.id ?? null,
                atmosphere_id   : this.atmosfera.id ?? null,
                container_id    : this.container.id ?? null,
                unit_payment    : this.unityPayment.id ?? null
            } ;
        },
        async exportExcel(){
            this.disabledBtn = true ;

            const form = this.generatePayload();

            this.$vToastify.loader("Exportando Recargos...");

            try {

                const data = await getTariffRechargeExport( form ) ;
                
                downloadFile( data , "tariff_recharges.xlsx" ) ;

                this.$vToastify.stopLoader();
                
                this.disabledBtn = false ;

            } catch (error) {

                this.$vToastify.stopLoader();

                this.disabledBtn = false ;

                return this.$vToastify.error(
                    "Error al exportar a excel, favor recargar página y volver a intentar",
                    "Error"
                );
            }
        },
        async filtrar(){

            this.disabledBtn = true ;

            const form = this.generatePayload();
            
            try {

                this.$vToastify.loader("Filtrando Recargos...");

                if( form.tariff_recharges_type.length == 0 
                    && form.naviera_id.length == 0
                    && form.naviera_id_departure.length == 0
                    && form.pol.length == 0
                    && form.pod.length == 0  
                    && form.from == ""  
                    && form.to == ""  
                    && form.products_category_id == null  
                    && form.atmosphere_id == null  
                    && form.container_id == null  
                    && form.unit_payment == null  
                ){
                    this.actionSetFilterStateRecargos( null );
                } 
                else {
                    this.actionSetFilterStateRecargos( form );
                }
                const { data } = await getRechargeFiltros( form ) ;

                const data_table = !data.data ? [] : data.data.map( d => ({
                    data: [
                        d.naviera_name,
                        d.naviera_departure,
                        d.name,
                        d.code,
                        d.pol_name,
                        d.pod_name,
                        d.from_format,
                        d.to_format,
                        d.currency_name,
                        d.neta,
                        d.public_value,
                        d.atmosphere_name,
                        d.container_name,
                        d.products_category_name,
                        d.unit_payment_name
                    ],
                    data_complementaria: d 
                })) ;
                
                this.disabledBtn = false ;

                this.actionSetDataDatatableTarifasRecargos( data_table );
                this.$vToastify.stopLoader();
                this.cerrarModal();

            } catch (error) {
                this.$vToastify.stopLoader();
                this.disabledBtn = false ;

                return this.$vToastify.error(
                    "Error al filtrar recargos, por favor recargue la página y vuelva a intentar.",
                    "Lo sentimos"
                );
                
            }
        },
        resetForm(){
            this.naviera = [];
            this.navieraDeparture = [];
            this.pol = [];
            this.pod = [];
            this.from =  "";
            this.to =  "";
            this.neta =  "";
            this.public_value =  "";
            this.atmosfera = {};
            this.container = {};
            this.commodity = {};
            this.unityPayment = {};
            this.typeRecharge = [];

            this.actionSetFilterStateRecargos( null );
        },
        async recargarTabla(){
            this.resetForm();

            this.$vToastify.loader("Recargando Tabla...");

            const { data } = await getRecargos() ;

            const data_table = !data.data ? [] : data.data.map( d => ({
                data: [
                    d.naviera_name,
                    d.naviera_departure,
                    d.name,
                    d.code,
                    d.pol_name,
                    d.pod_name,
                    d.from_format,
                    d.to_format,
                    d.currency_name,
                    d.neta,
                    d.public_value,
                    d.atmosphere_name,
                    d.container_name,
                    d.products_category_name,
                    d.unit_payment_name
                ],
                data_complementaria: d 
            })) ;
            
            this.actionSetDataDatatableTarifasRecargos( data_table );
            this.$vToastify.stopLoader();
        },
        openModal() {
            this.ActionSetZindexTablaModal(true);
            this.$refs["modal"].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
        cerrarModal(){
            this.closeModal("modal");
            this.ActionSetZindexTablaModal(false);
        },
    },

    watch: {
        showModalFiltrosTarifasRecargos: function (_new) {
            _new ? this.openModal() : this.cerrarModal() ;
        },
      
    },
}
</script>

<style>
    #filtrosRecargos .container-fluid .mx-input{
        border: 0px;
        border-bottom: 1px solid #ccc;
        box-shadow: none;
        border-radius: 0px;
    }

    #filtrosRecargos .container-fluid .label-datepicker{
        color: rgba(0, 0, 0, 0.54);
        font-size: 0.9375rem;
        margin-bottom: 0px;
    }
</style>